import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "configurations/Constants";
import { LogoutSvg } from "assets/icons/LogoutSvg";
import { AuthHelper } from "utils/AuthHelper";
import "styles/Sidebar.css";
import { resetSiteFilters } from "reduxStore/slices/siteFilterSlice";
import { resetPlantedAcresFilters } from "reduxStore/slices/plantedAcresFilterSlice";

const Sidebar = ({ handleCloseSidebar, expandable }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeLink = useSelector((state) => state.sidebar.active);
  const [expandedView, setExpandedView] = useState(true);

  const handleItemClick = (item) => {
    navigate(item.route);
    handleCloseSidebar(true);
    if (item.route === "sites") {
      dispatch(resetSiteFilters());
      dispatch(resetPlantedAcresFilters());
    }
  };

  const handleLogout = () => {
    AuthHelper.clearSession();
    navigate("/login", { replace: true });
    navigate(0);
  };

  const toggleExpandedView = () => {
    setExpandedView(!expandedView);
  };

  return (
    <div
      className={`d-flex flex-column sidebar-container ${
        expandedView ? "sidebar-expanded" : "sidebar-collapsed"
      }`}
    >
      {expandable && (
        <div className="sidebar-toggle-arrow" onClick={toggleExpandedView}>
          <i className={`fa fa-chevron-${expandedView ? "left" : "right"}`}></i>
        </div>
      )}
      <div className="flex-grow-1">
        {ROUTES.map((item) => {
          return (
            <div
              key={item.label}
              onClick={() => handleItemClick(item)}
              className={`d-flex align-items-center gap-2 py-2 px-3 ${
                activeLink === item.route
                  ? "sidebar-option-active"
                  : "sidebar-option"
              }`}
            >
              <div title={item.label}>{item.icon}</div>
              {expandedView && <small>{item.label}</small>}
            </div>
          );
        })}
      </div>
      <div className="sidebar-option-logout">
        <div
          onClick={handleLogout}
          className="logout-button d-flex align-items-center gap-2 py-2 px-3"
        >
          <LogoutSvg />
          {expandedView && <small>Log out</small>}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
